import React from "react";

export interface MainLogoProps {
  mode: "dark" | "light";
  onclickUrl: string;
  w: number;
  h: number;
}

export const MainLogoNew: React.FC<MainLogoProps> = ({
  mode,
  onclickUrl,
  w,
  h,
}) => {
  return (
    <a
      href={onclickUrl}
      className={`block ${mode === "light" ? "max-w-40" : "max-w-64"}`}
    >
      <svg
        viewBox={`0 0 ` + w + ` ` + h}
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-auto"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          id="layer1"
          className={mode === "dark" ? "fill-white" : "fill-black"}
        >
          <path
            style={{ fill: "#3396e7" }}
            d="M 41.143445,4.3837625 45.116235,9.4068267 18.904982,33.471864 26.074262,25.389298 3.5618079,43.198339 Z"
          />
          <path
            style={{ fill: "#4158e6" }}
            d="M 56.131535,0.71422449 62.008225,8.5928575 28.362595,39.267853 10.667966,49.858801 30.299962,30.420538 1.0457029,55.154272 Z"
          />
          <path
            style={{ fill: "#f82315" }}
            d="m 61.362435,10.465648 1.29158,8.39526 L 22.227596,52.054483 34.1747,39.461591 9.6347019,59.416482 60.974955,10.530224 Z"
          />
          <path
            style={{ fill: "#f82315" }}
            d="m 61.297855,22.089854 1.48531,8.072369 L 24.294121,64.195326 53.354645,34.230697 31.78528,49.083852 Z"
          />

          <path
            style={{ fill: "#ffffff" }}
            d="m 95.951917,19.989509 v 3.71021 h -2.60286 v -3.71021 h 2.67135 z"
          />
          <path
            style={{ fill: "#ffffff" }}
            d="m 98.428407,14.661789 v 20.43923 h 5.715233 v -11.52734 z"
          />
          <path
            style={{ fill: "#ffffff" }}
            d="m 123.25901,34.971859 h 5.71523 v -19.98718 l -5.8121,8.81503 z"
          />
          <path
            style={{ fill: "#ffffff" }}
            d="m 98.234667,9.2694487 h 6.102713 l 9.17021,14.5948303 9.78371,-14.5625503 h 6.03813 L 113.50759,34.003179 Z"
          />
          <path
            style={{ fill: "#ffffff" }}
            d="M 158.68312,9.3611587 H 136.44465 V 19.909589 h -4.52076 v 3.65314 h 24.52168 v -3.56181 h -13.97325 v -5.38837 h 16.34779 z"
          />
          <path
            style={{ fill: "#ffffff" }}
            d="m 136.53598,25.937269 v 8.99585 h 22.37546 v -5.38838 h -16.57611 v -3.60747 z"
          />
          <path
            style={{ fill: "#ffffff" }}
            d="m 48.038744,120.5535 v 15.06919 l 9.437489,0.17108 a 16.42772,16.42772 161.97062 0 0 10.206446,-3.32207 12.354734,12.354734 86.852926 0 0 -1.109986,-20.18813 16.252609,16.252609 15.84929 0 0 -9.090195,-2.58071 l -9.535083,0.11956 v 5.57103 l 11.412456,0.0367 a 6.3268679,6.3268679 23.974114 0 1 4.663931,2.074 l 0.780336,0.8595 a 6.530973,6.530973 87.47796 0 1 0.367256,8.33794 l -0.677731,0.89313 a 6.4887567,6.4887567 153.43497 0 1 -5.13255,2.56628 l -4.929379,0.0277 v -9.72647 h -6.529983 l -0.07155,0.26704 z"
            transform="translate(18.99631,-100.64391)"
          />
          <text
            x="114.31483"
            y="46.983562"
            style={{
              fontSize: "12.7px",
              fontWeight: "bold",
              fontFamily: "Arial",
              fill: "#ffffff",
              textAnchor: "middle",
              letterSpacing: "5.82083px",
            }}
          >
            TECH
          </text>
          <text
            x="114.02901"
            y="54.234753"
            style={{
              fontSize: "3.88056px",
              fontWeight: "bold",
              fontFamily: "Arial",
              fill: "#ffffff",
              textAnchor: "middle",
            }}
          >
            -{" "}
            <tspan style={{ fontSize: "4.58611px" }}>
              SOFTWARE DEVELOPMENT
            </tspan>{" "}
            -
          </text>
          <text
            x="173.10869"
            y="17.793859"
            style={{
              fontSize: "11.2889px",
              fontWeight: "bold",
              fontFamily: "Arial",
              fill: "#ffffff",
              textAnchor: "middle",
            }}
          >
            ®
          </text>
          <rect
            x="67.046471"
            y="40.561237"
            width="15.069187"
            height="4.3837638"
            style={{ fill: "#50b3fb" }}
          />
          <rect
            x="144.03807"
            y="40.542706"
            width="15.069187"
            height="4.3837638"
            style={{ fill: "#4eb3ff" }}
          />
        </g>
      </svg>
    </a>
  );
};
